// extracted by mini-css-extract-plugin
module.exports = {"root":"EntitlementTokens_root__ytYcb","ui":"EntitlementTokens_ui__OHE8V","hash":"EntitlementTokens_hash__tkSw2","label":"EntitlementTokens_label__AL7b8"};